import React from "react";
import "./VideoPlayer.css";

const VideoPlayer = (props) => {
  return (
    <div className="vp_surround">
      <div className="vp_close" onClick={() => props.vtDismiss()}></div>
      <div className="vp_title">{props.previewTitle}</div>
      <iframe src={props.previewItem} title="video" className="vp_player"></iframe>
    </div>
  );
};

export default VideoPlayer;
